import {createContext, useContext} from "react";

type ITableContext = {
  gridTemplateColumns: string;
};

export const TableContext = createContext<ITableContext>({} as ITableContext);
export const useTable = () => useContext(TableContext);
